import * as React from 'react'
import type {SVGProps} from 'react'
const SvgZoom = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 25 25" {...props}>
        <path
            fill="#142745"
            fillRule="evenodd"
            d="M9.854 2.496c-4.064 0-7.358 3.294-7.358 7.358s3.294 7.358 7.358 7.358 7.358-3.294 7.358-7.358-3.294-7.358-7.358-7.358M9.881 0c5.456 0 9.879 4.424 9.879 9.88a9.84 9.84 0 0 1-2.075 6.058l6.654 6.653a1.235 1.235 0 1 1-1.746 1.748l-6.654-6.654a9.83 9.83 0 0 1-6.058 2.075C4.424 19.76 0 15.336 0 9.88S4.424 0 9.881 0m.519 5.2H9.1l-.001 3.899L5.2 9.1v1.3l3.899-.001L9.1 14.3h1.3l-.001-3.901 3.901.001V9.1l-3.901-.001z"
        />
    </svg>
)
export default SvgZoom
